import { useDateService } from 'framework/utils';
import { FieldProps, DurationBetweenTwoDatesIconField, useFieldHelper } from 'framework/ui/field';
import PriorityHigh from '@mui/icons-material/PriorityHigh';
import { Box } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';

const AssignMemberTimeField = ({ dateFromSource, dateToSource, ...props }: FieldProps) => {
  const { getDaysBetween, getMomentDateObjAsUtc, getCurrentDate } = useDateService();

  const { getValue: getDateFromValue } = useFieldHelper({ source: dateFromSource });
  const { getValue: getDateToValue } = useFieldHelper({ source: dateToSource });
  const today = getCurrentDate();

  const startDate = getDateFromValue();
  const endDate = getDateToValue();
  const startMoment = startDate ? getMomentDateObjAsUtc(startDate) : null;
  const isFutureStart = Boolean(startMoment?.isAfter(today, 'day'));

  const daysDiff = getDaysBetween(endDate, today) || 0;

  return (
    <Tooltip title={`${startDate} — ${endDate}`}>
      <Box display="flex" alignItems="center">
        <DurationBetweenTwoDatesIconField
          dateFromValue={today}
          dateToSource={isFutureStart ? dateFromSource : dateToSource}
          iconSx={{ fontSize: 12 }}
          prefix={isFutureStart ? 'start in ' : 'expire in '}
          textColor={
            isFutureStart || daysDiff > 10 ? 'var(--mui-palette-text-secondary)' : 'var(--mui-palette-error-main)'
          }
          granularity={'hours'}
          {...props}
        />

        {!isFutureStart && daysDiff <= 10 ? <PriorityHigh color="error" sx={{ fontSize: 16 }} /> : null}
      </Box>
    </Tooltip>
  );
};

export default AssignMemberTimeField;
